import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment-timezone'
import Header from './Header'
import ScheduleBox from '../sitewide/ScheduleBox'
import LoadingSpinner from '../sitewide/Spinner'
import * as PatientActions from '../../state/actions/selected-patient'
import { renderAlert } from '../../services/render-alert'
import css from './styles.css'
import fetchApi from '../../services/fetchApi'

require('react-datepicker/dist/react-datepicker.css')

class Schedule extends Component {
  constructor(props) {
    super(props)

    this.state = {
      date: moment(),
      appointments: [],
      loaded: false,
    }
  }

  componentDidMount() {
    this.fetchAppointments(this.state.date)
  }

  componentWillReceiveProps({ activeLocation: nextActiveLocation }) {
    const { activeLocation } = this.props
    if (
      activeLocation
      && nextActiveLocation
      && activeLocation.id !== nextActiveLocation.id
    ) {
      const { date } = this.state
      this.fetchAppointments(date, nextActiveLocation.id)
    }
  }

  fetchAppointments = async (date = null, activeLocationId = '') => {
    const { hasDSO, activeLocation } = this.props

    let url = '/appointments/'
    if (hasDSO) {
      url = activeLocationId
        ? `${url}${activeLocationId}`
        : `${url}${activeLocation.id}`
    }
    url = date ? `${url}?date=${date.format('YYYY-MM-DD')}` : url

    try {
      const { appointments } = await fetchApi(url, 'GET')
      this.setState({
        appointments,
        loaded: true,
      })
    } catch (err) {
      console.error(err)
    }
  }

  handleChange = async (date) => {
    try {
      await this.fetchAppointments(date)
      this.setState({ date })
    } catch (err) {
      console.error(err)
    }
  }

  handleRequestReview = async (patientId, appointmentId, type) => {
    const { requestReview } = this.props
    const { date } = this.state
    try {
      const { body } = await requestReview(patientId, appointmentId, type)
      if (body && body.opted_out) {
        renderAlert(`Patient is opted out of messages via ${type}.`, 'error')
        return true
      } else if (body && body.message_create_failure) {
        renderAlert(
          `Unable to create review message via ${type}. Please check that patient's ${type} information is valid.`,
          'error',
        )
        return true
      }
      renderAlert(`Review successfully requested via ${type}.`, 'success')
      this.fetchAppointments(date)
      return true
    } catch (err) {
      console.error(err)
      return false
    }
  }

  render() {
    const { appointments, date } = this.state
    const { hasReviews, hasTopsRemindersPlus, pmsType } = this.props
    const requestReview = (hasReviews || hasTopsRemindersPlus) ? this.handleRequestReview : null

    return !this.state.loaded ? (
      <LoadingSpinner />
    ) : (
      <div className={css.wrapper}>
        <div className={css.subWrapper}>
          <Header date={date} handleChange={this.handleChange} />
          <ScheduleBox
            requestReview={requestReview}
            appointments={appointments}
            pmsType={pmsType}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    auth: {
      hasDSO,
      hasReviews,
      hasTopsRemindersPlus,
      pmsType,
    },
    user: { activeLocation },
  },
}) => ({
  activeLocation,
  hasDSO,
  hasReviews,
  hasTopsRemindersPlus,
  pmsType,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...PatientActions }, dispatch)

Schedule.propTypes = {
  requestReview: PropTypes.func.isRequired,
  hasDSO: PropTypes.bool.isRequired,
  hasReviews: PropTypes.bool.isRequired,
  hasTopsRemindersPlus: PropTypes.bool.isRequired,
  pmsType: PropTypes.string,
  activeLocation: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    additional_recipients: PropTypes.arrayOf(PropTypes.object),
    city: PropTypes.string,
    country_code: PropTypes.string,
    created_at: PropTypes.string,
    doctor_id: PropTypes.string,
    earliest_same_day_reminder_hour: PropTypes.number,
    facebook_url: PropTypes.string,
    forwarding_email: PropTypes.string,
    google_url: PropTypes.string,
    id: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    name: PropTypes.string,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.object),
    practice_id: PropTypes.number,
    state: PropTypes.string,
    street_address: PropTypes.string,
    timezone: PropTypes.string,
    updated_at: PropTypes.string,
    website: PropTypes.string,
    yelp_url: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedule)



// WEBPACK FOOTER //
// ./src/components/Schedule/index.js